/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SimulatorHistoryItem_result = {
    readonly uuid: string;
    readonly start: string;
    readonly end: string;
    readonly isCorrect: boolean;
    readonly identifiedStatus: string;
    readonly identification: {
        readonly isSearch: boolean;
    } | null;
    readonly image: {
        readonly normal: {
            readonly images: {
                readonly topURL: string;
            };
        };
        readonly threat: {
            readonly threatXray: {
                readonly images: {
                    readonly topURL: string;
                };
            };
            readonly topPosition: {
                readonly x: number;
                readonly y: number;
                readonly scale: number;
                readonly rotation: number;
            };
        } | null;
        readonly alwaysSearch: boolean;
    };
    readonly " $refType": "SimulatorHistoryItem_result";
};
export type SimulatorHistoryItem_result$data = SimulatorHistoryItem_result;
export type SimulatorHistoryItem_result$key = {
    readonly " $data"?: SimulatorHistoryItem_result$data;
    readonly " $fragmentRefs": FragmentRefs<"SimulatorHistoryItem_result">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "images",
            "storageKey": null,
            "args": null,
            "concreteType": "ImageURLs",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "topURL",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "SimulatorHistoryItem_result",
        "type": "ImageResult",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "uuid",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "start",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "end",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCorrect",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "identifiedStatus",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "identification",
                "storageKey": null,
                "args": null,
                "concreteType": "Identification",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isSearch",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "image",
                "storageKey": null,
                "args": null,
                "concreteType": "PackagedImage",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "normal",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "NormalXray",
                        "plural": false,
                        "selections": (v0 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "threat",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ThreatBundle",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "threatXray",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ThreatXray",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "topPosition",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ThreatPosition",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "x",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "y",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "scale",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "rotation",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "alwaysSearch",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '780681a30a46a5d40e9cc263f364c5ef';
export default node;
